const Colors = {
  MainRed: '#9D1B43',
  MainYellow: '#D9AF32',
  MainGreen: '#509603',
  MainBlack: '#333',
  MainWhite: '#fafafa'
}

export default Colors;